import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Entity} from '../../entity/entity';
import {EntityComplexity} from '../../model/entity-complexity';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-complexity-info-dialog',
    templateUrl: './complexity-info-dialog.component.html',
    styleUrls: ['./complexity-info-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class ComplexityInfoDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<ComplexityInfoDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  private readonly entity: Entity;
  private readonly entityComplexity: EntityComplexity;
  distinctConfigurations!: number;
  averageSfrCount!: number;
  entityType!: string;

  constructor() {
    const data = this.data;

    this.entity = data.entity;
    this.entityComplexity = data.complexity;
  }

  ngOnInit(): void {
    if (this.entity && this.entity.lines && this.entity.lines.length > 0) {
      const allPrns: string[] = this.entity.lines.filter(line => line.prn && line.prn.trim().length > 0).map(line => line.prn);
      const distinctPrns: Set<string> = new Set(allPrns);
      this.distinctConfigurations = distinctPrns.size;
      this.averageSfrCount = this.getAverageSfrCount(allPrns);
      this.entityType = 'QUOTE' === this.entity.id.entityName ? 'Quote' : 'Order';
    }
  }

  private getAverageSfrCount(prns: string[]): number {
    if (!prns || prns.length === 0) {
      return 0;
    }
    const prnCount = prns.length;
    let sfrCount = 0;
    for (const prn of prns) {
      sfrCount += this.getSfrCount(prn);
    }
    return Math.round(sfrCount / prnCount);
  }

  private getSfrCount(prn: string) {
    if (!prn || prn.trim().length === 0) {
      return 0;
    }
    const fields: string[] = prn.split('_');
    return fields.filter(field => field && field.trim().length > 0 && field.startsWith('SFR')).length;
  }

  close(): void {
    this.dialogRef.close();
  }

}
